import React from 'react'
import { CategoryTitle, Processes } from 'components'

const Juridical = ({ juridical }) => {
  const isVisibleSection = juridical && !!juridical.contencioso.length

  if (!isVisibleSection) return null

  return (
    <section>
      <CategoryTitle icon="expenses" title="Processo" />
      <Processes litigation={juridical.contencioso} />
    </section>
  )
}

export default Juridical
